import type { CommitmentOccurrence } from "../../domain/commitments";
import { validCommitmentDate } from "../../engine/commitments";

/** Routes carry identities only. Names, amounts and defaults are read at the source. */
export type SpendingContext = { kind: "expense" | "allocation" | "purchase" | "mileage" | "record" | "document"; id: string }
  | { kind: "bill"; id: string; sourceDate: string; dueDate: string };
export const spendingFocus = (context: SpendingContext): string => `spending:${JSON.stringify(context)}`;
export function parseSpendingFocus(focus?: string): SpendingContext | null {
  if (!focus?.startsWith("spending:")) return null;
  try {
    const value = JSON.parse(focus.slice(9));
    if (!value || typeof value.id !== "string" || !value.id || value.id.length > 2000) return null;
    if (["expense", "allocation", "purchase", "mileage", "record", "document"].includes(value.kind)) return { kind: value.kind, id: value.id };
    if (value.kind === "bill" && validCommitmentDate(value.sourceDate) && validCommitmentDate(value.dueDate)) return { kind: "bill", id: value.id, sourceDate: value.sourceDate, dueDate: value.dueDate };
  } catch { /* Malformed links never select another record. */ }
  return null;
}
export function billSpendingFocus(occurrence: CommitmentOccurrence): string {
  return spendingFocus({ kind: "bill", id: occurrence.commitmentId, sourceDate: occurrence.sourceDate, dueDate: occurrence.dueDate });
}
export const recordSpendingFocus=(featureId?:string)=>spendingFocus({kind:"record",id:featureId??"project"});
